import { render, staticRenderFns } from "./createClass.vue?vue&type=template&id=1b6aaaa9&scoped=true"
import script from "./createClass.vue?vue&type=script&lang=js"
export * from "./createClass.vue?vue&type=script&lang=js"
import style0 from "./createClass.vue?vue&type=style&index=0&id=1b6aaaa9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6aaaa9",
  null
  
)

export default component.exports